<template>
  <div class="cps">
        <slot name="csrf"></slot>

        <!-- 1. Pesquisa -->
        <form class="mb-3" @submit.prevent="getProcessoSeletivoERP()" novalidate>
            <fieldset class="ec-form-secao mb-0">
                <legend><b-icon icon="funnel"></b-icon> Processos seletivos do ERP</legend>
                <ol class="cps-passos">
                    <li><b>Busque</b> os processos seletivos do ano letivo.</li>
                    <li>Em cada curso, clique em <b>Configurar</b> e escolha a <b>turma do ERP</b> que recebe as inscrições.</li>
                    <li><b>Salve</b>: a turma é exportada para o CRM como oferta.</li>
                </ol>
                <div class="form-row align-items-end">
                    <div class="form-group col-sm-4 col-lg-2 mb-sm-0">
                        <label for="anoInicio">Ano letivo</label>
                        <input class="form-control" type="number" inputmode="numeric" min="2000" max="2100" id="anoInicio" name="anoInicio" placeholder="Ex.: 2026" v-model="anoInicio" :readonly="visualizar"/>
                    </div>
                    <div class="form-group col-sm-8 col-lg-10 mb-0 d-flex flex-wrap justify-content-sm-end" style="gap:.5rem;">
                        <a :href="'/Access/Unity/Unitie/'+unitie.id+'/oferta_processo_seletivo'" class="btn btn-outline-primary"><b-icon icon="list-ul"></b-icon> Ver exportações</a>
                        <button type="submit" class="btn btn-primary"><b-icon icon="search"></b-icon> Buscar processos</button>
                    </div>
                </div>
                <p class="form-text text-muted mb-0 mt-2">
                    Esta tela apenas consulta o ERP. Se um processo não aparecer, procure o responsável pelo ERP na instituição.
                </p>
            </fieldset>
        </form>

        <template v-if="processos_filtrados.length>0">
            <!-- 2. Resumo e filtros da lista -->
            <div class="cps-barra">
                <div class="cps-resumo">
                    <span><b>{{ processos_filtrados.length }}</b> processo(s)</span>
                    <span><b>{{ resumoGeral.total }}</b> curso(s)</span>
                    <span class="ec-status ec-status--sucesso">{{ resumoGeral.configurados }} configurado(s)</span>
                    <span class="ec-status ec-status--aguardando" v-if="resumoGeral.total-resumoGeral.configurados>0">{{ resumoGeral.total-resumoGeral.configurados }} pendente(s)</span>
                </div>
                <div class="cps-filtros">
                    <div class="cps-busca">
                        <b-icon icon="search"></b-icon>
                        <input type="search" class="form-control form-control-sm" v-model="buscaCurso" placeholder="Buscar curso ou turno" aria-label="Buscar curso ou turno">
                    </div>
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="cpsSomentePendentes" v-model="somentePendentes">
                        <label class="custom-control-label" for="cpsSomentePendentes">Só pendentes</label>
                    </div>
                </div>
            </div>

            <!-- 3. Processos seletivos -->
            <details class="ec-card cps-pse" v-for="processo_seletivo,i in processos_filtrados" :key="i" :open="processos_filtrados.length==1 || !!buscaCurso || somentePendentes">
                <summary class="ec-card__cabecalho">
                    <span class="ec-card__icone"><i class="fa-solid fa-clipboard-list"></i></span>
                    <div class="ec-card__textos">
                        <h3 class="ec-card__titulo">{{ (processo_seletivo.descricaoProcesso!='' && processo_seletivo.idProcesso>0?processo_seletivo.descricaoProcesso:'INFORMAÇÃO') }}</h3>
                        <p class="ec-card__subtitulo cps-pse__meta">
                            <span>Processo {{ processo_seletivo.idProcesso }}</span>
                            <span>{{ processo_seletivo.ano }}/{{ processo_seletivo.semestre }} · chamada {{ processo_seletivo.chamada }}</span>
                            <span v-if="processo_seletivo.descricaoTipoProcesso">{{ processo_seletivo.descricaoTipoProcesso }}</span>
                            <span><b-icon icon="calendar3"></b-icon> {{ formatDate(processo_seletivo.dataInicio,2) }} a {{ formatDate(processo_seletivo.dataTermino,2) }}</span>
                            <span><b-icon icon="cash"></b-icon> {{ valorInscricao(processo_seletivo) }}</span>
                        </p>
                    </div>
                    <span class="ec-card__extra cps-pse__extra">
                        <span class="ec-card__etiqueta" v-if="processo_seletivo.descricaoModalidade">{{ processo_seletivo.descricaoModalidade }}</span>
                        <span class="ec-status" :class="resumoPse(processo_seletivo).configurados==resumoPse(processo_seletivo).total ? 'ec-status--sucesso' : 'ec-status--aguardando'">
                            {{ resumoPse(processo_seletivo).configurados }}/{{ resumoPse(processo_seletivo).total }} configurados
                        </span>
                    </span>
                </summary>

                <div class="ec-card__corpo ec-card__corpo--flush">
                    <ul class="cps-cursos">
                        <li v-for="curso,item in cursosVisiveis(processo_seletivo)" :key="item" class="cps-curso" :class="{'cps-curso--aberto':curso.configurarturma}">
                            <div class="cps-curso__linha">
                                <div class="cps-curso__info">
                                    <span class="cps-curso__nome">{{ curso.descricaoCurso }}</span>
                                    <span class="cps-curso__detalhes">
                                        <span v-if="curso.descricaoTurno"><b-icon icon="clock"></b-icon> {{ curso.descricaoTurno }}</span>
                                        <span v-if="curso.vagas"><b-icon icon="people"></b-icon> {{ curso.vagas }} vagas</span>
                                        <span v-if="curso.DESCRICAONIVELENSINO">{{ curso.DESCRICAONIVELENSINO }}</span>
                                        <span class="cps-curso__turma"><b-icon icon="diagram-3"></b-icon> Turma no ERP:
                                            <b v-if="curso.turma_configurada && descricaoTurma(curso)">{{ descricaoTurma(curso) }}</b>
                                            <i v-else-if="curso.turma_configurada" class="text-muted">nome não disponível — clique em Alterar para carregar</i>
                                            <i v-else class="text-muted">não definida</i>
                                        </span>
                                    </span>
                                </div>
                                <div class="cps-curso__status">
                                    <span v-if="curso.turma_configurada" class="ec-status ec-status--sucesso"><b-icon icon="check-circle-fill"></b-icon> Configurado</span>
                                    <span v-else class="ec-status ec-status--aguardando"><b-icon icon="exclamation-circle-fill"></b-icon> Sem turma</span>
                                </div>
                                <div class="cps-curso__acoes" v-if="!visualizar">
                                    <button v-if="!curso.configurarturma" type="button" class="btn btn-sm" :class="curso.turma_configurada ? 'btn-outline-primary' : 'btn-primary'" @click="abrirConfiguracao(curso,processo_seletivo)">
                                        <i class="fa-solid fa-gear"></i> {{ curso.turma_configurada ? 'Alterar' : 'Configurar' }}
                                    </button>
                                </div>
                            </div>

                            <!-- painel de configuração do curso -->
                            <div class="cps-config" v-if="curso.configurarturma">
                                <div class="form-row">
                                    <div class="form-group col-lg-8">
                                        <label :for="'turma-'+i+'-'+item">Turma do ERP <span class="ec-obrigatorio">*</span></label>
                                        <select :id="'turma-'+i+'-'+item" v-model="curso.turma" class="custom-select" :disabled="!curso.listaturmas">
                                            <option :value="0">{{ curso.listaturmas ? (curso.listaturmas.length ? 'Selecione a turma' : 'Nenhuma turma encontrada no ERP') : 'Carregando turmas...' }}</option>
                                            <option v-for="turma,item_turma in (curso.listaturmas || [])" :key="item_turma" :value="turma.CODIGOTURMA">{{ turma.DESCRICAOTURMA.trim() }} — CRM: {{ turma.DESCRICAOOFERTAPSE }}</option>
                                        </select>
                                        <small class="form-text text-muted">Turma do ERP que recebe as inscrições deste curso. O nome após “CRM” é como a oferta aparece no CRM.</small>
                                    </div>
                                    <div class="form-group col-lg-4">
                                        <span class="d-block mb-2 font-weight-bold">Dados do curso</span>
                                        <dl class="cps-dados">
                                            <dt>Modalidade</dt><dd>{{ processo_seletivo.descricaoModalidade || '—' }}</dd>
                                            <dt>Nível de ensino</dt><dd>{{ curso.DESCRICAONIVELENSINO || '—' }}</dd>
                                        </dl>
                                    </div>
                                </div>

                                <div v-if="curso.polos && curso.polos.length>0" class="cps-polos">
                                    <span class="d-block mb-2 font-weight-bold">Polos vinculados ({{ curso.polos.length }})</span>
                                    <ul>
                                        <li v-for="polo, ipl in curso.polos" :key="ipl">
                                            <span>{{ polo.descricaoUnidadePolo }} <small class="text-muted">({{ polo.idEmpresaPolo }}-{{ polo.idUnidadePolo }})</small></span>
                                            <span v-if="polo.existe_crm" class="ec-status ec-status--sucesso">No CRM</span>
                                            <span v-else class="ec-status ec-status--erro" title="Cadastre este local de oferta no CRM">Não está no CRM</span>
                                        </li>
                                    </ul>
                                </div>

                                <div class="cps-config__acoes">
                                    <button type="button" class="btn btn-sm btn-outline-danger mr-auto" v-if="curso.turma_configurada" @click="confirmarExclusao(processo_seletivo,curso)">
                                        <b-icon icon="trash"></b-icon> Remover configuração
                                    </button>
                                    <button type="button" class="btn btn-sm btn-outline-secondary" @click="curso.configurarturma=false">Cancelar</button>
                                    <button type="button" class="btn btn-sm btn-primary" @click="salvarPse(processo_seletivo,curso)" :disabled="!curso.turma || curso.turma==0">
                                        <i class="fa-solid fa-floppy-disk"></i> Salvar e exportar
                                    </button>
                                </div>
                            </div>
                        </li>
                        <li v-if="cursosVisiveis(processo_seletivo).length==0" class="cps-vazio cps-vazio--mini">
                            Nenhum curso deste processo corresponde ao filtro.
                        </li>
                    </ul>
                </div>
            </details>
        </template>

        <div v-else class="ec-card cps-vazio">
            <b-icon :icon="msgCancelamento ? 'x-circle' : 'search'" font-scale="2"></b-icon>
            <p class="mb-0">{{ msgCancelamento ? msgCancelamento : 'Informe o ano letivo e clique em “Buscar processos” para listar os processos seletivos do ERP.' }}</p>
        </div>

        <loading id="carregandoPses" titulo="Buscando Processos Seletivos Ativos no ERP ..." :sem-padding="true" gif-carregando="/imagens/carregando.gif" @cancelaRequisicao="cancelarRequisicao()"></loading>
        <loading id="carregandoCursos" titulo="Obtendo dados de cursos do PSE ..." :sem-padding="true" gif-carregando="/imagens/carregando.gif" @cancelaRequisicao="cancelarRequisicao()"></loading>
        <loading id="carregandoTurmas" titulo="Obtendo dados de Turmas do PSE no ERP <br>Verificando se os Polos existem no CRM ..." :sem-padding="true" gif-carregando="/imagens/carregando.gif" @cancelaRequisicao="cancelarRequisicao()"></loading>
        <loading id="salvandoConfiguracoes" titulo="Salvando as configurações" :sem-padding="true" gif-carregando="/imagens/carregando.gif" @cancelaRequisicao="cancelarRequisicao()"></loading>
  </div>
</template>

<script>
export default {
    props:['usuarioLogado','unitie','urlRedirect','filtroEditado','visualizar'],
    data(){
        return{
            anoInicio:null,
            dataInicio:null,
            dataTermino:null,
            dataInicioFormat:null,
            dataTerminoFormat:null,
            todos_cursos:[],
            processos_filtrados:[],
            modalidades:[],
            niveisensino:[],
            cod_curso_selecionado:0,
            pse_salvar:{
                processo:{},
                turma_salva:{}
            },
            urlapigvdasa:null,
            tokenapigvdasa:null,
            urlapirubeus:null,
            tokenapirubeus:null,
            filtroPesquisaProcessoSeletivo:{
                ano:null,
                semestre:null,
                idEmpresa:null,
                idUnidade:null,
                idUnidadePk:null,
                dataInicio:null,
                dataTermino:null,
                idCurso:null,
                curso:null,
                oferta_processo_seletivo:0,
                oferta_Inscricao_web:1,
                inscricao_web_aluno:0,
                importar_parcela:0,
                download_contrato:0
            },
            curso_selecionado:{
                CODIGOCURSO:null,
            },
            turma_selecionada:{

            },
            semestre_selecionado:"",
            ofertaCursoTurma:{
                codCurso:null,
                codOferta:null,
                codigo:null,
                nomeCurso:null,
                descricaoCurso:null,
                nome:null,
                codUnidade:null,
                inicioInscricao:null,
                terminoInscricao:null,
                inicioMatricula:null,
                terminoMatricula:null,
                inicioCurso:null,
                terminoCurso:null,
                codNivelEnsino:2,
                modalidade:1,
                codLocalOferta:null,
                origem:null

            },
            dadosFiltro:{

            },
            error:{
                msg:null,
            },
            CancelToken:null,
            cancelTokenSource:null,
            cursosErpEmBusca:{},
            msgCancelamento:null,
            buscaCurso:'',
            somentePendentes:false,
        }
    },
    computed:{
        resumoGeral(){
            let total = 0, configurados = 0
            this.processos_filtrados.forEach(pse => {
                const r = this.resumoPse(pse)
                total += r.total
                configurados += r.configurados
            })
            return { total, configurados }
        }
    },
    created(){
        // this.anoInicio = this.anoTurma;
        // 
         
        if(this.unitie.urlapigvdasa!="" && this.unitie.urlapigvdasa){
            this.urlapigvdasa = this.unitie.urlapigvdasa;
        }else if(this.unitie.companies.urlapigvdasa!="" && this.unitie.companies.urlapigvdasa){
            this.urlapigvdasa = this.unitie.companies.urlapigvdasa;
        } 

        if(this.unitie.tokenapigvdasa!="" && this.unitie.tokenapigvdasa){
            this.tokenapigvdasa = this.unitie.tokenapigvdasa;
        }else if(this.unitie.companies.tokenapigvdasa!="" && this.unitie.companies.tokenapigvdasa){
            this.tokenapigvdasa = this.unitie.companies.tokenapigvdasa;
        } 

        if(this.unitie.urlapirubeus!="" && this.unitie.urlapirubeus){
            this.urlapirubeus = this.unitie.urlapirubeus;
        }else if(this.unitie.companies.urlapirubeus!="" && this.unitie.companies.urlapirubeus){
            this.urlapirubeus = this.unitie.companies.urlapirubeus;
        } 

        if(this.unitie.tokenapirubeus!="" && this.unitie.tokenapirubeus){
            this.tokenapirubeus = this.unitie.tokenapirubeus;
        }else if(this.unitie.companies.tokenapirubeus!="" && this.unitie.companies.tokenapirubeus){
            this.tokenapirubeus = this.unitie.companies.tokenapirubeus;
        } 

        // if(this.urlapigvdasa!="" && this.tokenapigvdasa!=""){
        //     this.getCursosERP();
        // }

        let dataAtual = new Date();
        if(this.filtroEditado.id>0){
            dataAtual =new Date()
            this.anoInicio = this.filtroEditado.anoliberacaoinscricaocursoweb
            this.cod_curso_selecionado = this.filtroEditado.idcurso
            this.filtroPesquisaProcessoSeletivo.curso = this.filtroEditado.nomecurso
            this.semestre_selecionado = (this.filtroEditado.semestre==null ? '':this.filtroEditado.semestre);
            this.dataInicio = new Date(this.filtroEditado.datainicio)
            this.dataTermino = new Date(this.filtroEditado.datatermino)
        }else{

            this.anoInicio = dataAtual.getFullYear();
            

        }
        this.filtroPesquisaProcessoSeletivo.idEmpresa = this.unitie.companies.codigoempresa
        this.filtroPesquisaProcessoSeletivo.idUnidade = this.unitie.codigounidade
        // this.getProcessoSeletivoERP()
        
        
    },
    watch:{
        cod_curso_selecionado(new_curso,old_curso){
            if(new_curso!=old_curso){

                for(let i=0;i<this.todos_cursos.length;i++){
                    // console.log(this.todos_cursos[i].CODIGOCURSO) 
                    if(this.todos_cursos[i].CODIGOCURSO==new_curso){
                        this.curso_selecionado=this.todos_cursos[i]
                        this.filtroPesquisaProcessoSeletivo.curso = this.curso_selecionado.DESCRICAO
                        // console.log('CURSO',this.cursos[i].DESCRICAO)
                    }
                }

                this.cod_curso_selecionado = new_curso
                this.ofertaCursoTurma.curso
                if(new_curso>0){
                    this.filtroPesquisaProcessoSeletivo.idCurso = new_curso
                }else{
                    this.filtroPesquisaProcessoSeletivo.idCurso = null
                }
            }
        },
        semestre_selecionado(new_semestre,old_semestre){
            if(new_semestre!=old_semestre){
                this.semestre_selecionado = new_semestre;
                this.filtroPesquisaProcessoSeletivo.semestre = this.semestre_selecionado;
            }

        },
        dataInicio(newDataInicio,oldDataInicio){
            if(newDataInicio!=oldDataInicio){
                if(this.formatDate(this.dataInicio,1)=='1969-12-31'){
                    // console.log('data',this.dataInicio)
                    this.filtroPesquisaProcessoSeletivo.dataInicio=null
                    this.dataInicio = null
                }else{
                    this.dataInicio = newDataInicio;
                    this.filtroPesquisaProcessoSeletivo.dataInicio = this.formatDate(this.dataInicio,1)
                }
            }
        },
        dataTermino(newDataTermino,oldDataTermino){
            if(newDataTermino!=oldDataTermino){
                if(this.formatDate(this.dataTermino,1)=='1969-12-31'){
                    // console.log('data',this.dataInicio)
                    this.filtroPesquisaProcessoSeletivo.dataTermino=null
                    this.dataTermino = null
                }else{
                        this.dataTermino = newDataTermino;
                        this.filtroPesquisaProcessoSeletivo.dataTermino = this.formatDate(newDataTermino,1);
                    }
            }
        },
        anoInicio(newAno,oldAno){
            if(newAno!=oldAno){
                this.anoInicio=newAno
                this.filtroPesquisaProcessoSeletivo.ano = newAno;
            }
        }
    },
    methods:{
        desSelecionaPSE(){
            this.pse_salvar = {
                processo:{},
                turma_salva:{}
            }
        },
        cancelarRequisicao(){
            
            this.cancelTokenSource.cancel("Pesquisa de PSES do ERP cancelada");
            this.msgCancelamento = "Pesquisa de PSES do ERP cancelada"
            
        },
        formatDate(date,idioma) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) 
                month = '0' + month;
            if (day.length < 2) 
                day = '0' + day;

            if(idioma==1){
                return [year, month, day].join('-');
            }else if(idioma==2){
                return [day, month, year].join('/');
            }else{
                return [year, month, day].join('-');
            }
        },
        async getCursoERP(curso,cancelToken){
            // o mesmo curso aparece em vários PSEs/turnos: busca no ERP uma única vez por pesquisa
            if(!this.cursosErpEmBusca[curso.idCurso]){
                var config = {
                    method: 'get',
                    url: '/api/v1/Erp/Curso/' + this.unitie.id +'/id/'+curso.idCurso,
                    cancelToken: cancelToken,
                };
                this.cursosErpEmBusca[curso.idCurso] = axios(config).then(response => response.data.cursoErp)
            }

            //executa requisição
            await this.cursosErpEmBusca[curso.idCurso]
                .then(cursoErp => {
                    // $set: campos novos no objeto, para a tela atualizar (ex.: nível de ensino)
                    ['CODIGOCURSO','DESCRICAOESTRUTURAACADEMICA','DESCRICAONIVELENSINO','CODIGONIVELENSINO','CODIGOESTRUTURAACADEMICA']
                        .forEach(campo => this.$set(curso, campo, cursoErp[campo]))
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        async getTurmasERP(curso,pse){
            // if(curso.listaturmas==null){
                
                $('#carregandoTurmas').modal('show');

                let dadosPesquisa = {
                    ano: this.anoInicio,
                    idCurso: curso.idCurso,
                    idEmpresa: this.unitie.companies.codigoempresa,
                    idUnidade: this.unitie.codigounidade,
                    idProcesso: pse.idProcesso,
                    codigoturno: curso.idTurno
                    
                }
                console.log('dadosPesquisa',dadosPesquisa);
                this.CancelToken = axios.CancelToken;
                this.cancelTokenSource = this.CancelToken.source();
                this.msgCancelamento = null

                var url= '/api/v1/Erp/Turmas/' + this.unitie.id;
               
                let formData = new FormData();
                formData.append('dados',JSON.stringify(dadosPesquisa))
                var config = {
                        // method: 'post',
                        // url: '/api/v1/Erp/Inscricoes/' + this.unitie.id,
                        // headers:{
                        //             'Accept': 'application/json',
                        //             'Authorization': 'Bearer '+this.tokenapigvdasa,
                        //             'Gvdasa':1
                        //         }
                        cancelToken: this.cancelTokenSource.token
                    };
                    
                    //executa requisição
                    await axios.post(url,formData,config)
                    .then(response => {
                        
                        curso.listaturmas = response.data.turmas
                        //console.log('in turmas',curso.listaturmas)
                        $('#carregandoTurmas').modal('hide');
                        
                        this.validaExistenciaPolos(curso)
                    })
                    .catch(function (error) {
                        console.log(error);
                        $('#carregandoTurmas').modal('hide');
                    });


            // }
        },
        async getTurmaConfiguradaErpByIdCurso(curso,pse,cancelToken){
            let dadosPesquisa = {
                ano: this.anoInicio,
                idCurso: curso.idCurso,
                idEmpresa: this.unitie.companies.codigoempresa,
                idUnidade: this.unitie.codigounidade,
                idProcesso: pse.idProcesso,
                idTurno:curso.idTurno
                
            }
            //console.log('dadosPesquisa',dadosPesquisa);
            if(!cancelToken){
                this.CancelToken = axios.CancelToken;
                this.cancelTokenSource = this.CancelToken.source();
                this.msgCancelamento = null
                cancelToken = this.cancelTokenSource.token
            }

            var url= '/api/v1/Erp/TurmaConfigurada/' + this.unitie.id;
            
            let formData = new FormData();
            formData.append('dados',JSON.stringify(dadosPesquisa))
            var config = {
                    // method: 'post',
                    // url: '/api/v1/Erp/Inscricoes/' + this.unitie.id,
                    // headers:{
                    //             'Accept': 'application/json',
                    //             'Authorization': 'Bearer '+this.tokenapigvdasa,
                    //             'Gvdasa':1
                    //         }
                    cancelToken: cancelToken
                };
                
                //executa requisição
                await axios.post(url,formData,config)
                .then(response => {
                    
                    curso.turma = response.data.turma_configurada
                    curso.turma_configurada = (response.data.turma_configurada>0 ? true : false)
                    this.$set(curso, 'descricao_turma', response.data.descricao_turma || null)
                   // console.log('in turmas configuradas',curso.turma)
                    
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        async getTodosCursosPse(){
            $('#carregandoCursos').modal('show');

            // uma só fonte de cancelamento para o lote: o "Cancelar" interrompe todas as buscas
            this.CancelToken = axios.CancelToken;
            this.cancelTokenSource = this.CancelToken.source();
            this.msgCancelamento = null
            const cancelToken = this.cancelTokenSource.token
            this.cursosErpEmBusca = {}

            let tarefas = []
            this.processos_filtrados.forEach(pse => {
                (pse.cursos || []).forEach(curso => {
                    tarefas.push(() => Promise.all([
                        this.getCursoERP(curso,cancelToken),
                        this.getTurmaConfiguradaErpByIdCurso(curso,pse,cancelToken),
                    ]))
                })
            })

            // antes era um curso por vez (2 requisições em sequência para cada um);
            // agora roda em paralelo, limitado para não sobrecarregar o servidor/ERP
            const LIMITE_SIMULTANEAS = 6
            let proxima = 0
            const trabalhador = async () => {
                while(proxima < tarefas.length && !this.msgCancelamento){
                    await tarefas[proxima++]()
                }
            }
            await Promise.all(Array.from({ length: Math.min(LIMITE_SIMULTANEAS, tarefas.length) }, trabalhador))

            $('#carregandoCursos').modal('hide');
            
        },
        async getTodasTurmasPse(){
            
            if(this.processos_filtrados.length>0){
                for(let iPse = 0; iPse < this.processos_filtrados.length; iPse++){
                    
                    for(let iCur = 0; iCur < this.processos_filtrados[iPse].cursos.length; iCur++){
                        
                        
                        let tur = await this.getTurmasERP(this.processos_filtrados[iPse].cursos[iCur],this.processos_filtrados[iPse]);
                        // console.log('cursos_ose',this.processos_filtrados[iPse].cursos[iCur])

                    }

                }
            }
            
        },
        async getProcessoSeletivoERP(){
            this.CancelToken = axios.CancelToken;
            this.cancelTokenSource = this.CancelToken.source();
            this.msgCancelamento = null
            $('#carregandoPses').modal('show');
            var url= '/api/v1/Erp/ProcessoSeletivo/' + this.unitie.id;
            // console.log(this.filtroPesquisaProcessoSeletivo)
            let formData = new FormData();
            formData.append('filtroPesquisaProcessoSeletivo',JSON.stringify(this.filtroPesquisaProcessoSeletivo))
            var config = {
                    // method: 'post',
                    // url: '/api/v1/Erp/Inscricoes/' + this.unitie.id,
                    // headers:{
                    //             'Accept': 'application/json',
                    //             'Authorization': 'Bearer '+this.tokenapigvdasa,
                    //             'Gvdasa':1
                    //         }
                    cancelToken: this.cancelTokenSource.token
                };
                
                //executa requisição
                await axios.post(url,formData,config)
                .then(response => {
                    
                    if(response.data.InscricoesErp){
                        this.processos_filtrados = response.data.InscricoesErp
                        this.modalidades = response.data.modalidades
                        this.niveisensino = response.data.niveisensino
                        
                        $('#carregandoPses').modal('hide');
                        
                    }else{
                        console.log(response.data)
                        $('#carregandoPses').modal('hide');
                    }
                    
                })
                .catch(function (error) {
                    console.log(error);
                    $('#carregandoPses').modal('hide');
                });

                if(this.processos_filtrados.length>0){
                    this.getTodosCursosPse()
                }
                
                //console.log('curso',this.processos_filtrados);
        },
        async validaExistenciaPolos(curso){
            
            if(curso.polos && curso.polos.length>0 && !curso.polo_atualizado){
                
                $('#sincronizandoPolos').modal('show');

                for(let iPol = 0; iPol < curso.polos.length; iPol ++ ){
                    let codigoexterno = curso.polos[iPol].idEmpresaPolo+'-' + curso.polos[iPol].idUnidadePolo
                    this.localOfertaExisteCrmByCodigoExterno(curso.polos[iPol],codigoexterno)
                }

                $('#sincronizandoPolos').modal('hide');

            }

            curso.polo_atualizado = true;
        },
        async localOfertaExisteCrmByCodigoExterno(polo,codigoexterno){
            this.CancelToken = axios.CancelToken;
            this.cancelTokenSource = this.CancelToken.source();
            this.msgCancelamento = null
            var url= '/api/v1/Crm/localOferta/'+ this.unitie.id +'/codigoexterno/' +codigoexterno ;
            // console.log(this.filtroPesquisaProcessoSeletivo)
            
            var config = {
                    // method: 'post',
                    // url: '/api/v1/Erp/Inscricoes/' + this.unitie.id,
                    // headers:{
                    //             'Accept': 'application/json',
                    //             'Authorization': 'Bearer '+this.tokenapigvdasa,
                    //             'Gvdasa':1
                    //         }
                    cancelToken: this.cancelTokenSource.token
                };
               
                //executa requisição
                await axios.get(url,config)
                .then(response => {
                    console.log(polo)
                    polo.existe_crm = response.data.existe_crm
                    
                })
                .catch(function (error) {
                    console.log(error);

                });
        },
        salvarPse(processo_seletivo,curso){
            this.pse_salvar.processo = {
                ano:processo_seletivo.ano,
                idProcesso:processo_seletivo.idProcesso,
                semestre:processo_seletivo.semestre,
                chamada:processo_seletivo.chamada,
                dataInicio:processo_seletivo.dataInicio,
                dataTermino:processo_seletivo.dataTermino,
                dataLimiteVencimento:processo_seletivo.dataLimiteVencimento,
                descricaoProcesso:processo_seletivo.descricaoProcesso,
                descricaoTipoProcesso:processo_seletivo.descricaoTipoProcesso,
                idTipoProcesso:processo_seletivo.idTipoProcesso,
                descricao:processo_seletivo.descricaoProcesso,
                descricaoModalidade:processo_seletivo.descricaoModalidade,
                tipoModalidade:processo_seletivo.tipoModalidade,
                polos:processo_seletivo.polos,
            }

            this.pse_salvar.turma_salva = curso

            if(curso.turma==0){
                window.alert('Selecione uma turma antes de salvar');

            }else{
                $('#salvandoConfiguracoes').modal('show');
                console.log(processo_seletivo,JSON.stringify(this.pse_salvar))
                let url='/api/v1/Erp/SalvarPse/'+this.unitie.id
                // console.log('pse',processo_seletivo)
                let formData = new FormData();
                formData.append('processos_seletivos',JSON.stringify(processo_seletivo))
                formData.append('curso_salvo',JSON.stringify(curso))
                formData.append('pse_salvar',JSON.stringify(this.pse_salvar))
                //console.log(curso)
                
                let configuracao = {
                    // method:'post',
                    // headers:{
                    //     'Accept': 'application/json',
                    //     'Authorization': this.tokenapirubeus,
                    //     'Rubeus':1
                    // }
                }

                axios.post(url,formData,configuracao)
                    .then(response => {
                         console.log('response',response.data)
                        if(response.data.msg){
                            this.error.msg = response.data.msg
                            curso.turma = 0

                            curso.turma_configurada = false
                            this.avisar(response.data.msg, 'danger', 'Não foi possível exportar')
                        }else{
                            curso.configurarturma = false
                            this.avisar(curso.descricaoCurso + (this.descricaoTurma(curso) ? ' (' + this.descricaoTurma(curso) + ')' : '') + ': turma exportada para o CRM.', 'success', 'Configuração salva')
                            for(let i=0 ;i< this.processos_filtrados.length;i++){
                                if(this.processos_filtrados[i].idProcesso==processo_seletivo.idProcesso){
                                    this.processos_filtrados[i]=processo_seletivo
                                    this.error.msg = null;
                                    curso.turma_configurada = true
                                    //$('#$('#salvandoConfiguracoes').modal('show');').modal('show');
                                    
                                }
                            }
                        }
                        $('#salvandoConfiguracoes').modal('hide');
                        //console.log(response.data.processos_seletivos)
                        
                    })
                    .catch(errors => {
                        // this.errors = errors.response.data.errors
                        console.log(errors.response)
                        $('#salvandoConfiguracoes').modal('hide');
                        this.avisar('Erro ao salvar a configuração. Tente novamente.', 'danger', 'Não foi possível salvar')
                    })

                
                //console.log(this.ofertaCursoTurma)
            }
            
        },
        excluirPse(idprocesso,course,school_class_id,idTurno){
            
            var config = {
                method: 'delete',
                url: '/api/v1/Erp/ExcluirPse/'+idprocesso+'/'+course+'/'+school_class_id+'/'+idTurno,
                // headers: {
                //         // 'Accept': 'application/json',
                //         // 'Authorization': this.$root.token(),
                //     },
                };
                //executa requisição
                axios(config)
                .then(response => {
                    //window.alert(response.data.msg);
                    
                    this.processos_filtrados.forEach(pse => {
                        if(pse.idProcesso==idprocesso){
                            pse.cursos.forEach(cur => {
                                if(cur.idCurso==course && cur.idTurno == idTurno){
                                //    window.alert(cur.turma)
                                   cur.turma = 0;
                                   cur.turma_configurada = false
                                   cur.configurarturma = false
                                   this.error.msg = response.data.msg
                                   //$('#ExclusaoTurmaPse').modal('show');
                                }
                            });
                        }
                    });
                    this.avisar(response.data.msg || 'Configuração removida.', 'success', 'Configuração removida')

                })
                .catch(error => {
                    console.log(error);
                    this.avisar('Erro ao remover a configuração. Tente novamente.', 'danger', 'Não foi possível remover')
                });
        },
        abrirConfiguracao(curso,processo_seletivo){
            // fecha outros painéis abertos para manter o foco em um curso por vez
            this.processos_filtrados.forEach(pse => (pse.cursos || []).forEach(cur => { if(cur!==curso) cur.configurarturma = false }))
            curso.configurarturma = true
            this.desSelecionaPSE()
            this.getTurmasERP(curso,processo_seletivo)
        },
        confirmarExclusao(processo_seletivo,curso){
            if(window.confirm('Remover a configuração de turma do curso ' + curso.descricaoCurso + '?')){
                this.excluirPse(processo_seletivo.idProcesso,curso.idCurso,curso.turma,curso.idTurno)
            }
        },
        avisar(mensagem,variante,titulo){
            this.$bvToast.toast(mensagem, {
                title: titulo,
                variant: variante,
                solid: true,
                toaster: 'b-toaster-top-right',
                autoHideDelay: variante=='danger' ? 8000 : 4000,
            })
        },
        descricaoTurma(curso){
            // nome da turma do ERP (a lista só existe depois de abrir a configuração do curso)
            // nome da turma no ERP (DESCRICAOCOMPLETA): o da lista do ERP, quando já carregada, ou o gravado na configuração
            const turma = (curso.listaturmas || []).find(t => t.CODIGOTURMA == curso.turma)
            const nome = (turma && turma.DESCRICAOCOMPLETA) || curso.descricao_turma
            return nome ? String(nome).trim() : null
        },
        valorInscricao(processo_seletivo){
            const valor = (processo_seletivo.valores || [])[0]
            if(!valor) return '—'
            return valor.isento ? 'Isento' : this.$root.numberToReal(parseFloat(valor.valorInscricao))
        },
        resumoPse(processo_seletivo){
            const cursos = processo_seletivo.cursos || []
            return { total: cursos.length, configurados: cursos.filter(c => c.turma_configurada).length }
        },
        cursosVisiveis(processo_seletivo){
            const busca = this.normalizar(this.buscaCurso)
            return (processo_seletivo.cursos || []).filter(curso => {
                if(this.somentePendentes && curso.turma_configurada && !curso.configurarturma) return false
                if(!busca) return true
                return this.normalizar(curso.descricaoCurso + ' ' + (curso.descricaoTurno || '')).includes(busca)
            })
        },
        normalizar(texto){
            return String(texto || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim()
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../../sass/variables';

.cps-passos {
    display: flex;
    flex-wrap: wrap;
    gap: .35rem 1.5rem;
    margin: 0 0 1rem;
    padding: 0;
    list-style: none;
    counter-reset: passo;
    font-size: .85rem;
    color: $ec-texto-suave;

    li {
        counter-increment: passo;
        display: flex;
        align-items: center;
        gap: .45rem;

        &::before {
            content: counter(passo);
            display: inline-flex;
            align-items: center;
            justify-content: center;
            flex: 0 0 1.4rem;
            height: 1.4rem;
            border-radius: 50%;
            font-size: .72rem;
            font-weight: 700;
            color: #fff;
            background: $ec-petroleo;
        }
    }
}

.cps-barra {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: .75rem;
    margin-bottom: .75rem;
}

.cps-resumo {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: .5rem .9rem;
    font-size: .85rem;
    color: $ec-texto-suave;

    b { color: $ec-texto; }
}

.cps-filtros {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: .75rem;
}

.cps-busca {
    position: relative;

    svg {
        position: absolute;
        left: .6rem;
        top: 50%;
        transform: translateY(-50%);
        color: $ec-texto-suave;
        pointer-events: none;
    }

    input { padding-left: 1.9rem; min-width: 220px; }
}

.cps-pse { margin-bottom: .75rem; }

.cps-pse__meta {
    display: flex;
    flex-wrap: wrap;
    gap: .15rem .9rem;
}

.cps-pse__extra {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: .4rem;
}

.cps-cursos {
    margin: 0;
    padding: 0;
    list-style: none;
}

.cps-curso {
    border-top: 1px solid $ec-borda;

    &--aberto { background: rgba($ec-petroleo, .03); }
}

.cps-curso__linha {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: .5rem 1rem;
    padding: .7rem 1.25rem;
}

.cps-curso__info {
    flex: 1 1 260px;
    min-width: 0;
}

.cps-curso__nome {
    display: block;
    font-weight: 600;
    color: $ec-texto;
}

.cps-curso__detalhes {
    display: flex;
    flex-wrap: wrap;
    gap: .1rem .9rem;
    font-size: .8rem;
    color: $ec-texto-suave;
}

.cps-curso__turma { flex-basis: 100%; color: $ec-texto; }

.cps-curso__acoes .btn { white-space: nowrap; }

.cps-config {
    margin: 0 1.25rem 1rem;
    padding: 1rem 1.1rem;
    background: $ec-superficie;
    border: 1px solid $ec-borda;
    border-left: 3px solid $ec-petroleo;
    border-radius: .5rem;
}

.cps-dados {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: .25rem .75rem;
    margin: 0;
    font-size: .85rem;

    dt { font-weight: 400; color: $ec-texto-suave; }
    dd { margin: 0; font-weight: 600; }
}

.cps-polos {
    margin-bottom: 1rem;

    ul {
        margin: 0;
        padding: 0;
        list-style: none;
        border: 1px solid $ec-borda;
        border-radius: .4rem;
        max-height: 220px;
        overflow-y: auto;
    }

    li {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: .75rem;
        padding: .4rem .75rem;
        font-size: .85rem;

        & + li { border-top: 1px solid $ec-borda; }
    }
}

.cps-config__acoes {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: .5rem;
}

.cps-vazio {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: .6rem;
    padding: 2rem 1rem;
    text-align: center;
    color: $ec-texto-suave;

    &--mini { padding: 1rem; border-top: 1px solid $ec-borda; }
}

@media (max-width: 575.98px) {
    .cps-busca input { min-width: 0; width: 100%; }
    .cps-busca, .cps-filtros { width: 100%; }
    .cps-curso__acoes { width: 100%; }
    .cps-curso__acoes .btn { width: 100%; }
}
</style>
